import axios from 'axios';

export default function() {
  return {
    namespaced: true,
    state: {
      brief: {
        temp: '-',
        humi: '-',
        status: null,
        warnings: [],
      },
      detail: {
        // [locale]: { detail }
      }
    },
    mutations: {
      SET_WEATHER(state, { data }) {
        // TODO: data validation
        state.brief = {
          ...state.brief,
          ...data
        }
      },
      SET_WEATHER_DETAIL(state, { data, locale }) {
        state.detail = {
          ...state.detail,
          [locale]: {...data}
        }
      }
    },
    actions: {
      FETCH_WEATHER({ state, commit }) {
        return axios.get(encodeURI(`/api/weather`))
          .then((res) => {
            const data = res.data || {};
            commit('SET_WEATHER', {data});
          }).catch(err => console.log(err));      
      },
      FETCH_WEATHER_DETAIL({ state, commit }, { locale }) {
        return axios.get(encodeURI(`/api/weather?detail=1`))
          .then((res) => {
            const data = res.data || {};
            commit('SET_WEATHER', {
              data: {
                temp: data.temp,
                humi: data.humi,
                status: data.status,
                warnings: data.warnings.filter(w => w.status != 2 && w.status != 3),
              }
            });
            commit('SET_WEATHER_DETAIL', {data, locale});
          }).catch(err => console.log(err));      
      },
    },
    getters: {
      getWeatherDetail: (state) => (locale) => {
        return state.detail[locale] || {};
      }
    }
  }
}